<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'report-one' }">
        ข้อมูลคำสั่งซื้อ
      </b-breadcrumb-item>
      <b-breadcrumb-item active> รายการคำสั่งซื้อ </b-breadcrumb-item>
    </b-breadcrumb>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>แสดง</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>รายการ</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="ค้นหา..."
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Add User</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative fix-minHeight-table"
        :items="fetchOrders"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="ไม่พบข้อมูลที่ค้นหา"
        :sort-desc.sync="isSortDirDesc"
      >
      <template #cell(index)="data">
          <div style="text-align: center;">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
            </div>
        </template>
        <template #cell(no)="data">
          <b-link
            :to="{ name: 'order-view', params: { id: data.item.id } }"
            class="font-weight-bold"
          >
            #{{ data.item.no }}
          </b-link>
        </template>
        

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>
        <template #cell(paymentOn)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.paymentOn.slice(0, 10)
            }}</span>
          </div>
        </template>
        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.role
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status ? "Active" : "Cancel" }}
          </b-badge>
        </template>

        <template #cell(shippingStatus)="data">
          <!-- <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(
              data.item.shippingStatus
            )}`"
            class="text-capitalize"
          >
            {{ data.item.shippingStatus ? "Active" : "Cancal" }}
          </b-badge> -->
        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- <feather-icon
              :id="`invoice-row-${data.item.id}-send-icon`"
              icon="SendIcon"
              class="cursor-pointer"
              size="16"
            />
            <b-tooltip
              title="Send Invoice"
              class="cursor-pointer"
              :target="`invoice-row-${data.item.id}-send-icon`"
            /> -->

            <feather-icon
              :id="`invoice-row-${data.item.id}-preview-icon`"
              icon="EyeIcon"
              size="16"
              class="mx-1"
              @click="
                $router.push({
                  name: 'order-view',
                  params: { id: data.item.id },
                })
              "
            />
            <b-tooltip
              title="Preview Invoice"
              :target="`invoice-row-${data.item.id}-preview-icon`"
            />

            <!-- Dropdown -->
            <!-- <b-dropdown
              variant="link"
              toggle-class="p-0"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
             
              <b-dropdown-item
                :to="{
                  name: 'order-view',
                  params: { id: data.item.id, isEdit: true },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">แก้ไข</span>
              </b-dropdown-item>
            
            </b-dropdown> -->
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >แสดง {{ dataMeta.from }} ถึง {{ dataMeta.to }} จาก
              {{ dataMeta.of }} รายการ</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="modal-saleorder"
      centered
      title="Status"
      ok-only
      ok-title="Save"
    >
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./OrdersListFilters.vue";
import useUsersList from "./useOrdersList";
import userStoreModule from "../orderStoreModule";
import UserListAddNew from "./OrderListAddNew.vue";

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
  },
  data() {
    return {
      selected: { title: "Active" },

      option: [{ title: "Active" }, { title: "Inactive" }],
    };
  },

  setup() {
    const SALE_ORDER_STORE_MODULE_NAME = "saleOrder";

    // Register module
    if (!store.hasModule(SALE_ORDER_STORE_MODULE_NAME))
      store.registerModule(SALE_ORDER_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = ref([{ label: "ทั้งหมด", value: "" }]);

    store.dispatch("saleOrder/getContract").then((response) => {
      if (response !== null) {
        response.data.data.forEach((data) => {
          planOptions.value.push({
            value: data.contactId,
            label: data.fullName,
          });
        });
      }
    });

    const statusOptions = [
      { label: "ทั้งหมด", value: "" },
      { label: "ใช้งาน", value: "active" },
      { label: "ยกเลิก", value: "inactive" },
      // { label: "All", value: "" },
      // { label: "Active", value: "active" },
      // { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchOrders,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchOrders,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },

  created() {
    // this.statusActiveMock("41d7bdb5-ca60-4650-bb9c-08da8fcc9a98", false);
  },
  methods: {
    // statusActiveMock(id, status) {
    //   console.log("this.orderMock", this.orderMock);
    //   this.orderMock = this.orderMock.map((order) => {
    //     if (order.id == id) {
    //       order.status = status;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.fix-minHeight-table {
  min-height: 15rem;
}
</style>
